import React from 'react';
import './bb-home-page.scss';
import Logo from '../header/components/Logo';
import { Link } from 'react-router-dom';
import SignInIcon from '../util/icons/components/SignInIcon';
import ArrowIcon from '../util/icons/components/ArrowIcon';

let loginDomain = 'https://goodbeefindex.org';
switch (window.location.host) {
  case 'localhost':
    loginDomain = 'http://localhost:8080';
    break;
  case 'test.beefbook.com':
    loginDomain = 'https://test.goodbeefindex.org';
    break;
}

const BBHomePage = () => {
  return (
    <div id="bb-home-page" className="bb-home-page">
      <div className="home-page-header">
        <Logo />
        <div className="menu">
          <Link className="about-link" to="/about">about</Link>
          <a className="sign-in"
            target="_blank"
            rel="noopener noreferrer"
            href={ `${loginDomain}/login` }>
            <SignInIcon />
            my account
          </a>
        </div>
      </div>
      <div className="center">
        <h1 data-cy="home-page-title" className="title">
          <span className="good">Good</span><span className="beef">Beef</span>
          <br/>
          <span className="good-for-you">is good for you</span>
        </h1>
        <ArrowIcon />
      </div>
      <nav className="big-links">
        <div className="find-out-more-box">
          <p>Measuring the genetic, environmental,
          production and eating quality of good beef animals</p>
          <Link className="find-out-how-button" to='/good-beef'>
            find out how
          </Link>
        </div>
        <Link to='/cattle/young-bulls'>
          <div className="home-page-menu-item">
            <h4 className="menu-item-title"
              data-cy="breeding-bulls-title">
              <span className="bold">Bulls </span>
              for Breeding
            </h4>
            <ArrowIcon />
          </div>
        </Link>
        <Link to='/cattle/cows'>
          <div className="home-page-menu-item">
            <h4 className="menu-item-title"
              data-cy="breeding-cows-title">
              <span className="bold">Cows </span>
              for Breeding
            </h4>
            <ArrowIcon />
          </div>
        </Link>
        <Link to='/cattle/heifers'>
          <div className="home-page-menu-item">
            <h4 className="menu-item-title"
              data-cy="breeding-heifers-title">
              <span className="bold">Heifers </span>
              for Breeding
            </h4>
            <ArrowIcon />
          </div>
        </Link>
        <Link to='/cattle/finished-cattle'>
          <div className="home-page-menu-item">
            <h4 className="menu-item-title"
              data-cy="animals-for-beef-title">
              <span className="bold">Animals </span>
              For Beef
            </h4>
            <ArrowIcon />
          </div>
        </Link>
      </nav>
    </div>
  );
};

export default BBHomePage;
